import InputField from 'components/fields/InputField';
import MultiSelect from 'components/multipleselectoption/Index';

const monthOptions = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
];

const AcademicMonthsConfig = ({
  academicMonths,
  setAcademicMonths,
  schoolData,
  setSchoolData,
}) => {
  const handleAcademicMonthChange = (index, field, value) => {
    const updatedMonths = [...academicMonths];
    updatedMonths[index][field] = value;

    if (field === 'startMonth') {
      updatedMonths[index].endMonth = value === 12 ? 12 : (value % 12) + 1;
    }

    setAcademicMonths(updatedMonths);
  };

  const addAcademicMonth = () => {
    setAcademicMonths([
      ...academicMonths,
      { startMonth: 1, endMonth: 2, appliesTo: 'specific', standards: [] },
    ]);
  };

  const removeAcademicMonth = (index) => {
    const updatedMonths = academicMonths.filter((_, i) => i !== index);
    setAcademicMonths(updatedMonths);
  };

  const canAddAcademicMonth = academicMonths.some(
    (config) => config.appliesTo === 'specific'
  );

  const handleTypeChange = (selectedTypes) => {
    setSchoolData({ ...schoolData, type: selectedTypes });
  };

  const typeOptions = ['SSC', 'HSC', 'Diploma', 'Institute'];

  return (
    <div className="mt-6">
      <div className="mb-3">
        <label className="text-sm text-navy-700 dark:text-white">
          Add the type of Boards in Your Organisation*
        </label>
        <MultiSelect
          options={typeOptions}
          selected={schoolData.type}
          onChange={handleTypeChange}
        />
      </div>
      <h5 className="mb-4 text-lg font-semibold text-navy-700 dark:text-white">
        Academic Months Configuration
      </h5>
      {academicMonths.map((config, index) => (
        <div
          key={index}
          className="mb-6 rounded-lg border p-4 dark:border-navy-600"
        >
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <div>
              <label className="mb-2 block text-sm font-bold text-navy-700 dark:text-white">
                Start Month
              </label>
              <select
                className="mt-1 block w-full items-center justify-center rounded-md rounded-xl border bg-white/0 p-3 text-sm outline-none dark:border-gray-800 dark:!bg-navy-800"
                value={config.startMonth}
                onChange={(e) =>
                  handleAcademicMonthChange(
                    index,
                    'startMonth',
                    parseInt(e.target.value)
                  )
                }
              >
                {monthOptions.map((month) => (
                  <option key={month.value} value={month.value}>
                    {month.label}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="mb-2 block text-sm font-bold text-navy-700 dark:text-white">
                End Month
              </label>
              <select
                className="mt-1 block w-full items-center justify-center rounded-md rounded-xl border bg-white/0 p-3 text-sm outline-none dark:border-gray-800 dark:!bg-navy-800"
                value={config.endMonth}
                disabled
              >
                {monthOptions.map((month) => (
                  <option key={month.value} value={month.value}>
                    {month.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-span-full">
              <label className="mb-2 block text-sm font-medium text-navy-700 dark:text-white">
                Applies To
              </label>
              <select
                className="mt-1 block w-full items-center justify-center rounded-md rounded-xl border bg-white/0 p-3 text-sm outline-none dark:border-gray-800 dark:!bg-navy-800"
                value={config.appliesTo}
                onChange={(e) =>
                  handleAcademicMonthChange(index, 'appliesTo', e.target.value)
                }
              >
                <option value="all">All Standards</option>
                {/* <option value="specific">Specific Standards</option> */}
              </select>
            </div>
            {config.appliesTo === 'specific' && (
              <div className="col-span-full">
                <InputField
                  type="text"
                  label="Standards (comma-separated)"
                  value={config.standards.join(',')}
                  onChange={(e) =>
                    handleAcademicMonthChange(
                      index,
                      'standards',
                      e.target.value.split(',').map((s) => s.trim())
                    )
                  }
                />
              </div>
            )}
          </div>
          {/* <button
            onClick={() => removeAcademicMonth(index)}
            className="mt-4 rounded bg-red-500 px-4 py-2 text-white hover:bg-red-600"
          >
            Remove
          </button> */}
        </div>
      ))}
      {canAddAcademicMonth && (
        <button
          onClick={addAcademicMonth}
          className="linear cursor-pointer rounded-xl bg-brand-900 px-6 py-2 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:ml-2"
        >
          Click here to Add More
        </button>
      )}

      <hr className="mb-2 mt-5 block w-full items-center justify-center border bg-white/0 text-sm outline-none dark:border-gray-800 dark:!bg-navy-800" />
    </div>
  );
};

export default AcademicMonthsConfig;
